$(document).ready(function(){
   $('a.zpa-icons-list__item__link[href ="/cart"]').click(function(e){
    e.preventDefault();
   $(".drawer").addClass("active");
   }); 
  $('a.zpa-btn-custom[href ="/cart"]').click(function(e){
    e.preventDefault();
   $(".drawer").addClass("active");
   }); 
 var cart_count= $(".cart-drawer").attr("data-count");
    $(".zpa-dynamic-header__cart").text(cart_count);

$.getJSON( "/cart.json", function( cart ) {
console.log(cart.item_count);
});
  $("select.hidden" ).addClass("hidden-selected-options");


  
  
     $("#zpproductselector1-wrapper form" ).attr('id', 'product-form-atc');
    
//    function CartBuild(){
//           $.ajax({
//             type:"get",
//             dataType: "html",
//             url: '/cart?view=ajax',
//             async:false,
//             success: function(data)
//             {
             
//            var find_parent=  $(data).find("#CartDrawer");
//            var htmlData= find_parent.html();
//               $("#CartDrawer").html(htmlData);
//            $('.drawer').removeClass('is-empty');
               
//            $('.drawer').addClass('animate active');
//             $('#CartDrawer').addClass('cart-drawer-custom');
//                $.getJSON( "/cart.json", function( cart ) {
//                     if (cart.item_count > 0) {
//                      $(".zpa-dynamic-header__cart").text(cart.item_count);
//                     }
//                  else{
//                    $('#CartDrawer').addClass('is-empty');
//  $(".zpa-dynamic-header__cart").text(cart.item_count);                 }
             
      
//           });
//          }
//           })  
//         }

// $("#product-form-atc .zpa-add-to-cart-btn").on("click",function(e){
//   e.preventDefault();
//     var parent = $(this).closest('form');
//           var formData = parent.serialize();
//           var id = $(parent).find("[name='id']").val();
//      var qty=$(parent).find(".zpa-quantity-field").val();
//   if(qty)
//   {
//     var qty=$(parent).find(".zpa-quantity-field").val();
    
//   }
//   else{
//         var qty=1;

//   }
 
//           $.ajax({
//             type:"post",
//             dataType: "json",
//             url: '/cart/add.js',
//             data:{id:id, quantity:qty},
//             async:false,
//             success: function(data)
//             {
//                            CartBuild();


//             }
//           });
            
// });
  
//  $('.zpa-cross-sell__checkbox').click(function(){
//       if($(this).is(":checked")){
//         var find_parent=$(this).closest(".zpa-offset-bottom-sm");
//         var find_Selected= find_parent.find('select.hidden-selected-options');
//       var id= find_Selected.children("option:selected").val();
//          var qty =find_parent.find(".zpa-quantity-field").val();
//      if(qty){
//         var qty =find_parent.find(".zpa-quantity-field").val();
//      }
//         else{
//           var qty =1;
//         }
//         console.log(qty)
//         $.ajax({
//             type:"post",
//             dataType: "json",
//             url: '/cart/add.js',
//             data:{id:id, quantity:qty},
//             async:false,
//             success: function(data)
//             {
//               console.log("Success");
//                  setTimeout(function(){ window.location.href = '/cart';},1000); 



//             }
//           });

 
//       }
     
//     });
});